// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import Axios from 'axios'

Vue.config.productionTip = false
Axios.defaults.baseURL = 'http://123.56.142.76:1717'
Vue.prototype.$axios = Axios //给Vue添加一个原型属性

Vue.prototype.COMPANY_NAME = "长沙企安智联信息科技有限公司" 
Vue.prototype.ICP = "湘ICP备2026009491号"              
Vue.prototype.EMAIL = "978337573@qq.com"           
Vue.prototype.ADDRESS = "湖南省长沙市芙蓉区长沙隆平产业开发区高家坡路900号长沙金茶农业科技有限公司科研楼101栋11楼1105"
Vue.prototype.JYXKZ = "" //湘B2-20240467
document.title = Vue.prototype.COMPANY_NAME 

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
})



// WEBPACK FOOTER //
// ./src/main.js